(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('ProvinciaDetailController', ProvinciaDetailController);

    ProvinciaDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Provincia'];

    function ProvinciaDetailController($scope, $rootScope, $stateParams, previousState, entity, Provincia) {
        var vm = this;

        vm.provincia = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('doctorclubboApp:provinciaUpdate', function(event, result) {
            vm.provincia = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
